export default function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-hierarchy/src/hierarchy/eachBefore.js
// module id = ../../../../d3-hierarchy/src/hierarchy/eachBefore.js
// module chunks = 4